import React, { useCallback, useEffect, useState } from 'react';

import { ExtraItemEnum } from 'enums';
import { getSelectedFilterValues } from 'utils/filterUtils';
import { WorkerSearchResponseModel } from 'api/backofficeApiClient';
import { getWorkersForTimesheetStatusReport } from 'redux/reducers/homeDashboardSlice';
import { TimesheetStatusReportFilters } from 'features/home/UserHomePage/TimesheetStatusReportDetailsPage/TimesheetStatusReportFilter';
import { TimesheetStatusReportFilterTypes } from '../enums';
import SelectWithLoading from 'hocs/withLoading/SelectWithLoading';
import { useAppDispatch } from 'hooks/useAppDispatch';

type Props = {
  isAdmin?: boolean;
  filters: TimesheetStatusReportFilters;
  onChange: (data: TimesheetStatusReportFilters) => void;
};

export default function WorkerFilter(props: Props) {
  const { filters, onChange, isAdmin } = props;
  const dispatch = useAppDispatch();
  const [workers, setWorkers] = useState<WorkerSearchResponseModel[]>([]);
  const [isWorkersLoaded, setIsWorkerLoaded] = useState(false);

  const loadWorkers = useCallback(async () => {
    const result = await dispatch(getWorkersForTimesheetStatusReport(isAdmin));

    if (getWorkersForTimesheetStatusReport.fulfilled.match(result)) {
      setWorkers(result.payload);
    }

    setIsWorkerLoaded(true);
  }, [dispatch, isAdmin]);

  useEffect(() => {
    loadWorkers();
  }, [loadWorkers]);

  const handleFilterChange =
    (type: TimesheetStatusReportFilterTypes) => (values: string[]) => {
      const selectedFilterValues = getSelectedFilterValues(
        values,
        ExtraItemEnum.All,
      );

      onChange({
        ...filters,
        [type]: selectedFilterValues,
      });
    };

  return (
    <SelectWithLoading
      isLoading={!isWorkersLoaded}
      className="full-width"
      value={filters[TimesheetStatusReportFilterTypes.Worker]}
      mode="multiple"
      optionFilterProp="children"
      placeholder="Select a worker"
      onChange={handleFilterChange(TimesheetStatusReportFilterTypes.Worker)}
      showSearch
      data-id="workerFilterField"
    >
      {isWorkersLoaded && (
        <>
          <SelectWithLoading.Option value={ExtraItemEnum.All}>
            {ExtraItemEnum.All}
          </SelectWithLoading.Option>
          {workers.map(({ id, workerFirstName, workerLastName, workerKey }) => (
            <SelectWithLoading.Option
              key={id}
              value={id || ''}
              label={`${workerFirstName} ${workerLastName}`}
            >
              {`${workerFirstName} ${workerLastName} ${workerKey}`}
            </SelectWithLoading.Option>
          ))}
        </>
      )}
    </SelectWithLoading>
  );
}
